import produce from 'immer'
import { isEmpty } from 'lodash'
import { createActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.operators, {
  useSelectionList: true,
  transformGetItemsParams: (params = {}) =>
    produce(params, (draft) => {
      draft.alwaysIncludeOperatorIds = draft.alwaysIncludeOperatorIds === false ? false : !isEmpty(draft.operatorIds)
    }),
  transformGetOptionsParams: (params = {}) =>
    produce(params, (draft) => {
      draft.alwaysIncludeOperatorIds = draft.alwaysIncludeOperatorIds === false ? false : !isEmpty(draft.operatorIds)
      draft.active = draft.active ?? 'Active'
    }),
})
